import _ from 'lodash';


const createHttpParams = (method, payload = {}) => {
    const params = {
        method: 'GET',
        headers: {},
    };

    if (method === 'POST') {
        params.method = 'POST';

        if (Object.keys(payload).length) {
            params.body = JSON.stringify(payload);
        }

        return params;
    }

    return params;
};

const lambdaClient = async (url, method, payload = {}, handleSuccess = () => {}, handleError = () => {}) => {
    try {
        const params = createHttpParams(method, payload);

        const rawResponse = await fetch(url, params);

        const content = await rawResponse.json();

        if (_.has(content, 'body-json')) {
            const bodyJson = _.get(content, 'body-json.body');

            if (_.get(content, 'body-json.statusCode') !== 200) {
                return handleError(_.get(content, 'body-json'));
            }

            return handleSuccess(bodyJson);
        }

        if (content.statusCode !== 200) {
            return handleError(content);
        }

        return handleSuccess(content);
    } catch (error) {
        return handleError(error);
    }
};

export default lambdaClient;
